import React from 'react';
import { motion } from 'framer-motion';
import { Phone, PhoneMissed, X } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

interface MissedCallCardProps {
  onDismiss: () => void;
}

export const MissedCallCard: React.FC<MissedCallCardProps> = ({ onDismiss }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="m-4 sm:m-6 max-w-7xl mx-auto"
    >
      <Card className="rounded-2xl border border-red-200 shadow-2xl shadow-black/5 bg-gradient-to-br from-red-50/30 to-red-100/20 backdrop-blur-md">
        <CardContent className="p-6 relative">
          {/* Dismiss Button */}
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
            className="absolute top-4 right-4 p-1 h-8 w-8 rounded-full hover:bg-red-100"
          >
            <X className="h-4 w-4 text-red-600" />
          </Button>

          <div className="flex items-start gap-3 mb-4">
            <div className="p-2 bg-red-100 rounded-xl">
              <PhoneMissed className="h-5 w-5 text-red-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-lg">Missed Call</h3>
              <p className="text-sm text-gray-600 mt-1">
                You have a missed call. Call back and Hana will give you a call immediately.
              </p>
            </div>
          </div>
          
          <div className="bg-red-50 rounded-2xl p-4">
            <div className="flex justify-between items-start mb-3">
              <div>
                <div className="text-red-700 font-medium text-sm">Missed call</div>
              </div>
              <div className="text-red-600 text-sm font-medium">
                Today at 2:30 PM
              </div>
            </div>
            
            <Button className="w-full bg-red-600 hover:bg-red-700 text-white rounded-xl flex items-center justify-center gap-2 py-3">
              <Phone className="h-4 w-4" />
              Call back
            </Button>
          </div>
          
          <p className="text-gray-500 text-sm mt-3 text-center">
            Available to call back anytime
          </p>
        </CardContent>
      </Card>
    </motion.div>
  );
};